import Image from 'next/image';
import Link from 'next/link';
import { useTheme } from '@mui/material/styles';
import { selfUrlToHomeHref } from '@/lib/appBasePath';

interface SidebarLogoProps {
  appUrl?: string;
}

const SidebarLogo: React.FC<SidebarLogoProps> = ({ appUrl = "" }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const href = selfUrlToHomeHref(appUrl);

  return (
    <Link
      href={href}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 2,
          borderRadius: 8,
          backgroundColor: 'transparent',
        }}
      >
        {isDark ? (
          <Image
            alt="boostt.ai logo"
            src="/v2/images/favicon-light.png"
            width={28}
            height={28}
            style={{ objectFit: 'contain' }}
          />
        ) : (
          <Image
            alt="boostt.ai logo"
            src="/v2/images/favicon-dark.png"
            width={28}
            height={28}
            style={{ objectFit: 'contain' }}
          />
        )}
      </span>
    </Link>
  );
};

export default SidebarLogo;
